export default __webpack_public_path__ + "static/r4-71b7e22a891b3f1f0245814726637927.png";